import { InternalHttpServiceRequestHeaders } from '../http.service';
import { getLocale } from '../../../util/locales/locales';
import { AxiosRequestHeaders } from 'axios';

export const acceptLanguageInterceptor = (config: InternalHttpServiceRequestHeaders): InternalHttpServiceRequestHeaders => {
  const locale = buildWeightedLocale();
  if (locale) {
    if (!config.headers) {
      (config.headers as Partial<AxiosRequestHeaders>) = { 'Accept-Language': locale };
    }

    config.headers['accept-language'] = locale;
  }
  return config;
};

const getNormalizedLocale = (locale: string | undefined) => {
  const split = locale?.split('-');
  if (split?.length !== 2) return locale;
  return `${split[0].toLowerCase()}-${split[1].toUpperCase()}`;
};

const buildWeightedLocale = () => {
  const locale = getLocale().RFC5646;
  const browserLocale = getNormalizedLocale(getBrowserLocale());
  if (!locale) return;
  if (!browserLocale || locale === browserLocale) return locale;
  return `${locale},${browserLocale};q=0.9`;
};

const getBrowserLocale = () => {
  if (typeof navigator !== 'undefined') {
    return navigator.language;
  }
};
